import {MicromorgiIcon} from '@/assets/icons/icons'
import {Modal} from '@/components/ui/modal/Modal'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {MegaGiftSection} from '@/features/mega-gift/components/mega-gift-section/MegaGiftSection'
import {useRootStore} from '@/store'
import {FC, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {css} from 'styled-components'
import {useGetPaidGifs} from '../queries/useGetPaidGifs'
import {Animation} from '../types'
import {
    StyledGif,
    StyledGifAmountContainer,
    StyledGifItem,
    StyledGifTitle,
    StyledGifsList,
    StyledOpenConfirmModalButton
} from './style'
// import {MessageTypeE} from '@/utilities/constants/chat'
import {useParams} from 'react-router-dom'
import {useMe} from '@/features/authentication/queries/useMe'
import {ChannelID} from '@/features/chat/types'
import {selectBuyMorgisModal, selectConfirmSendGiftModal, selectPaidGifsModal} from '@/store/selectors'
// import useSendChatMessage from '@/features/chat/hooks/useSendChatMessage'
import {USER_ROLE_GUEST} from '@/utilities/constants/user'
import {GuestTypeV3} from '@/features/authentication/types'
import {useGetChannelDetailsV3} from '@/features/chat/queries/useGetChannelDetailsV3'
import {useSendMessageV3} from '@/features/chat/queries/useSendMessageV3'
import {MessageTypeE} from '@/features/chat/chat.model'

export const OneTimeGifsModal: FC = () => {
    const {t} = useTranslation()
    const {closeModal, hostID, channelID, leaderID, minDonation} = useRootStore(selectPaidGifsModal)
    const {openModal: openConfirmSendGiftModal} = useRootStore(selectConfirmSendGiftModal)
    const {data: gifs, isLoading} = useGetPaidGifs({})

    const {channel} = useParams()
    const {data: user} = useMe()
    const isGuest = user?.type === USER_ROLE_GUEST
    const {data: channelDetails} = useGetChannelDetailsV3(channel as ChannelID)
    // const {sendChatMessage, isPending} = useSendChatMessage(channel as ChannelID)
    const {mutate: sendMessage} = useSendMessageV3({
        chatIdentifier: channelDetails ? channelDetails.pk : undefined
    })
    const [isLoadingSendChatMessage, setIsLoadingSendChatMessage] = useState(false)
    const {openModal: openBuyMorgisModal} = useRootStore(selectBuyMorgisModal)
    const guestMicroMorgiBalance = (user: GuestTypeV3) => user?.typeAttributes?.microMorgiBalance

    const onSelectGif = (gif: Animation) => {
        if (isLoadingSendChatMessage) return null
        if (gif.amount && hostID) {
            openConfirmSendGiftModal({
                hostID,
                amount: gif.amount,
                animationID: gif.id
            })
        } else if (channelID && leaderID) {
            if (user && channelDetails && !isLoadingSendChatMessage) {
                setIsLoadingSendChatMessage(true)
                // await sendChatMessage({
                //     type: MessageTypeE.GIFT_TRANSACTION,
                //     userId: leaderID,
                //     animationId: gif.id,
                //     micromorgiAmount: 0
                // })
                //     .then()
                //     .finally(() => {
                //         setIsLoadingSendChatMessage(false)
                //     })
                if (channelDetails)
                    sendMessage({
                        message: {
                            type: MessageTypeE.GIFT_TRANSACTION,
                            senderId: channelDetails.rookieId,
                            receiverId: channelDetails.leaderId,
                            metadata: {
                                animationId: gif.id
                            }
                        }
                    })

                closeModal()
            }
        }
    }

    return (
        <Modal
            modalStyles={() => css`
                padding-bottom: 20px;
                max-width: 400px;
            `}
            title={t('common:send_gift')}
            minHeight="580px"
            onClose={closeModal}
        >
            <StyledGifsList $isLoaded={!isLoading}>
                {!isLoading ? (
                    <>
                        {gifs?.map(gif => {
                            const disabled = minDonation ? gif.amount < minDonation : false
                            return (
                                !disabled && (
                                    <StyledGifItem key={gif.id}>
                                        <StyledGif src={gif.url} />
                                        <StyledGifTitle>{gif.name}</StyledGifTitle>
                                        {gif.amount ? (
                                            <StyledGifAmountContainer>
                                                <StyledGifAmountContainer>
                                                    <MicromorgiIcon height={14} width={14} />
                                                    {gif.amount}
                                                </StyledGifAmountContainer>
                                            </StyledGifAmountContainer>
                                        ) : (
                                            <br />
                                        )}
                                        <StyledOpenConfirmModalButton
                                            variant="primaryOutlined"
                                            disabled={isLoadingSendChatMessage}
                                            onClick={() => {
                                                if (
                                                    !isGuest ||
                                                    (isGuest &&
                                                        guestMicroMorgiBalance(user as GuestTypeV3) >= gif.amount)
                                                ) {
                                                    onSelectGif(gif)
                                                } else {
                                                    openBuyMorgisModal({})
                                                }
                                            }}
                                        >
                                            {t('common:send_now')}
                                        </StyledOpenConfirmModalButton>
                                    </StyledGifItem>
                                )
                            )
                        })}
                    </>
                ) : (
                    <Spinner />
                )}
            </StyledGifsList>
            {isGuest && <MegaGiftSection hostID={String(hostID)} />}
        </Modal>
    )
}
